import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLocation } from "react-router-dom";
import { isFilled, useSite, visibleModules } from "@/lib/content";
import { useSeo } from "@/lib/seo";
import { t } from "@/lib/i18n";
import PageIntro from "@/components/PageIntro";
import Reveal from "@/components/Reveal";
import { Pending, StatusLabel, StockBadge } from "@/components/Pending";

function ModuleBody({ m, isPreview }) {
  const showImg = m.image && (isPreview || m.image_stock === false);
  return (
    <div className="grid gap-6 md:grid-cols-[1fr_280px] items-start pb-4">
      <div className="space-y-4">
        {isPreview && m.status && <StatusLabel status={m.status} />}
        {isFilled(m.body) ? (
          <p className="text-base leading-relaxed text-ink-muted whitespace-pre-line" data-testid={`module-body-${m.id}`}>{m.body}</p>
        ) : (
          <Pending testId={`module-pending-${m.id}`} />
        )}
      </div>
      {showImg && (
        <div className="relative overflow-hidden rounded-xl aspect-[4/3]">
          <img src={m.image} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
          {isPreview && m.image_stock !== false && <StockBadge className="absolute top-2 left-2" />}
        </div>
      )}
    </div>
  );
}

export default function Kesfet() {
  useSeo("kesfet");
  const { content, isPreview } = useSite();
  const { hash } = useLocation();
  const modules = visibleModules(content, isPreview);
  const initial = hash ? [hash.slice(1)] : [];

  return (
    <div data-testid="kesfet-page">
      <PageIntro eyebrow={t("kesfet.eyebrow")} title={t("kesfet.title")} text={t("kesfet.text")} testId="kesfet-intro" />
      {modules.length > 0 && (
        <section className="safe-x max-w-7xl mx-auto pb-24 lg:pb-32" data-testid="kesfet-modules">
          <Accordion type="multiple" defaultValue={initial} className="border-t border-line">
            {modules.map((m, i) => (
              <Reveal key={m.id} delay={i * 60}>
                <AccordionItem value={m.id} id={m.id} className="border-line scroll-mt-28" data-testid={`module-${m.id}`}>
                  <AccordionTrigger headingLevel={2} className="min-h-[72px] py-6 gap-6 hover:no-underline text-left [&>svg]:h-6 [&>svg]:w-6 [&>svg]:text-honey-ink" data-testid={`module-trigger-${m.id}`}>
                    <span className="flex items-baseline gap-5">
                      <span className="font-serif text-lg text-honey-ink tabular-nums" aria-hidden="true">0{i + 1}</span>
                      <span className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold text-forest leading-tight">{m.title || t("preview.pending")}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pl-0 sm:pl-11">
                    <ModuleBody m={m} isPreview={isPreview} />
                  </AccordionContent>
                </AccordionItem>
              </Reveal>
            ))}
          </Accordion>
        </section>
      )}
    </div>
  );
}
